export var GAC_SEARCH_INITIATED = 'GAC_SEARCH_INITIATED';
export var GAC_SEARCH_RESULTS_READY = 'GAC_SEARCH_RESULTS_READY';
export var GAC_SUGGESTION_SELECTED = 'GAC_SEARCH_SELECTED';
export var GAC_SUGGESTION_INPUT_ERROR = 'GAC_SUGGESTION_INPUT_ERROR';
export var GAC_SET_REAL_NAMES = 'GAC_SET_REAL_NAMES';
export var GAC_SET_SEO_LABEL = 'GAC_SET_SEO_LABEL';